import { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, useFormik, FormikProvider } from 'formik';

// Components
import { FileUploader } from 'components/global/fileUploader';

// Store + Core
import { LEARNER_VALIDATION_TOOL_UPLOAD_FILE_TYPES } from 'core/constants';
import { batchLearnerValidation, batchLearnerValidationClearAction } from 'store/learner/actions';
import { learnerValidationFileSelector, uploadLearnerValidationPercentageSelector } from 'store/learner/selectors';
import { rollupOrganizationEnumSelector } from 'store/user/selectors';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from 'store';
import { PARSAction } from 'core/models';
import { visuallyHidden } from '@mui/utils';

// Types
export interface IBatchLearnerValidationFormValues {
  file: File;
}

export const LearnerValidationToolBatchForm = (): ReactElement => {
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();

  // Redux State.
  const uploadPercentage: number = useSelector(uploadLearnerValidationPercentageSelector);
  const uploadedFile = useSelector(learnerValidationFileSelector);
  const rollupOrganizationEnum = useSelector(rollupOrganizationEnumSelector);

  const onClearFile = (): void => {
    dispatch(batchLearnerValidationClearAction());
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: async (values): Promise<void> => {
      // API call - upload file.
      await dispatch(batchLearnerValidation({ file: values as { file: File }, rollupOrganizationEnum }));
    },
  });
  const { handleSubmit } = formik;

  return (
    <FormikProvider value={formik}>
      <form encType="multipart/form-data" onSubmit={handleSubmit}>
        <Field
          component={FileUploader}
          fileTypes={LEARNER_VALIDATION_TOOL_UPLOAD_FILE_TYPES}
          id="batchLearnerValidationFile"
          name="file"
          showDropZoneSubTitle={false}
          onClearFile={onClearFile}
          uploadedFile={uploadedFile}
          uploadPercentage={uploadPercentage}
        />
        <span style={visuallyHidden}>
          <button tabIndex={-1}>Submit</button>
        </span>
      </form>
    </FormikProvider>
  );
};
